import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';
import useDismissMenu from './useDismissMenu';
import { FOLLOW_FIRST_KEY, followFirstEnabled, useFollowSettingsVersion } from './followLists';
import './MatchSortMenu.css';

let nextMenuId = 0;

// A disclosure keeps ordering and the independent followed-first preference distinct.
export default function MatchSortMenu({ value, onChange, disabled = false }) {
  const [open, setOpen] = useState(false);
  const [panelLeft, setPanelLeft] = useState(0);
  const [id] = useState(() => `match-sort-${++nextMenuId}`);
  const trigger = useRef(null);
  const ref = useDismissMenu(open, setOpen);
  useFollowSettingsVersion();
  useLayoutEffect(() => {
    if (open && ref.current) {
      const anchor = ref.current.getBoundingClientRect();
      const width = ref.current.querySelector('.match-sort-menu__panel').getBoundingClientRect().width;
      const left = Math.max(12, Math.min(anchor.right - width, window.innerWidth - width - 12));
      setPanelLeft(left - anchor.left);
      ref.current.querySelector('input:checked')?.focus();
    }
  }, [open, ref]);
  useEffect(() => {
    const close = () => setOpen(false);
    window.addEventListener('resize', close);
    return () => window.removeEventListener('resize', close);
  }, []);
  const choose = order => {
    onChange(order);
    setOpen(false);
    trigger.current?.focus();
  };
  return <div className="match-sort-menu" ref={ref}>
    <button ref={trigger} type="button" className="match-sort" aria-label="Sortera och visa matcher"
      aria-expanded={open} aria-controls={id} disabled={disabled} onClick={() => setOpen(!open)} />
    {open && <div className="match-sort-menu__panel" id={id} style={{ left: panelLeft, right: 'auto' }}>
      <fieldset><legend className="shq-sr">Sortera matcher</legend>
        {[['league', 'Serie'], ['time', 'Starttid']].map(([order, label]) => <label key={order}>
          <input type="radio" name={id} value={order} checked={value === order} onClick={() => { if (value === order) choose(order); }} onChange={() => choose(order)} />{label}
        </label>)}
      </fieldset>
      <label className="match-sort-menu__follow"><input type="checkbox" checked={followFirstEnabled()} onChange={event => {
        try { (window.SportsHQSettings || window.localStorage).setItem(FOLLOW_FIRST_KEY, event.target.checked ? '1' : '0'); }
        catch { return; }
        window.dispatchEvent(new Event('sports-hq-settings-state'));
      }} />Det jag följer först</label>
    </div>}
  </div>;
}
